// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"56fb4a85b195e9a56100","339":"910932826a9e894fa2ba"}[chunkId] + ".js";
};